import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Portfolio from './components/Portfolio';

function App() {
  return (
    <div>
      <Portfolio />
    </div>
  );
}

export default App;
